// Storage constants
const APPOINTMENTS_STORAGE_KEY = 'patientAppointments';
const APPOINTMENTS_TIMESTAMP_KEY = 'patientAppointmentsTimestamp';

export const clearAppointmentsFromStorage = () => {
    try {
        localStorage.removeItem(APPOINTMENTS_STORAGE_KEY);
        localStorage.removeItem(APPOINTMENTS_TIMESTAMP_KEY);
    } catch (error) {
        console.error('Error clearing appointments from storage:', error);
    }
};
